import React from "react";
import { formatCurrencyUsd } from "../../shared/utils/financeDisplay";
import MetricStatCard from "../MetricStatCard";

/**
 * Three-up summary: income (green), expense (red), net (blue or red if negative).
 * Uses MetricStatCard + the same layout rules as Financial Reports list totals.
 */
export default function FinanceSummaryStatCards({ totalIncome, totalExpense, netCashFlow, style, className }) {
  const net = Number(netCashFlow);
  const netNegative = Number.isFinite(net) && net < 0;
  return (
    <div
      className={`cards-wrapper cards-wrapper--sm${className ? ` ${className}` : ""}`}
      style={{ marginBottom: 14, ...style }}
      role="region"
      aria-label="Financial summary"
    >
      <MetricStatCard label="Total Income" value={formatCurrencyUsd(totalIncome)} valueStyle={{ color: "#16a34a" }} />
      <MetricStatCard label="Total Expense" value={formatCurrencyUsd(totalExpense)} valueStyle={{ color: "#dc2626" }} />
      <MetricStatCard
        label="Net Cash Flow"
        value={formatCurrencyUsd(net)}
        valueStyle={{ color: netNegative ? "#dc2626" : "#2563eb" }}
      />
    </div>
  );
}
